import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateInboundEmailRules as UpdateInboundEmailRulesMutation,
    UpdateInboundEmailRulesVariables as UpdateInboundEmailRulesMutationVariables,
    InboundEmailRulesUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_INBOUND_EMAIL_RULES from '../mutations/update-inbound-email-rules.graphql';

export const useUpdateInboundEmailRules = (): {
    updateInboundEmailRules: (input: InboundEmailRulesUpdateInput) => Promise<unknown>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateInboundEmailRules, {loading, error}] = useMutation<
        UpdateInboundEmailRulesMutation,
        UpdateInboundEmailRulesMutationVariables
    >(UPDATE_INBOUND_EMAIL_RULES);

    return {
        updateInboundEmailRules: (input: InboundEmailRulesUpdateInput) => {
            return updateInboundEmailRules({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
